export default __webpack_public_path__ + "static/media/notification.b8c5531b.svg";